module.exports = __webpack_public_path__ + "img/google-slides-4.d533a117.webp";